import { IAuthResponse } from '@/features/account/api/auth.interfaces';

export class Utilities {
  public static findWithAttr(array: any[], attr: string, value: any): number {
    for (let i = 0; i < array.length; i += 1) {
      if (array[i][attr] === value) {
        return i;
      }
    }
    return -1;
  }

  public static getFileName(response: any) {
    let filename = '';
    const disposition = response.request.getResponseHeader('Content-Disposition');
    if (disposition && disposition.indexOf('attachment') !== -1) {
      const filenameRegex = /filename[^;=\n]*="((['"]).*?\2|[^;\n]*)"/;
      const matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
        return filename;
      }
    }
    return '';
  }

  public static setLocalStorage(auth: IAuthResponse) {
    localStorage.setItem('id', auth.id.toString());
    localStorage.setItem('access_token', auth.auth_token.access_token);
    localStorage.setItem('refresh_token', auth.auth_token.refresh_token);
    localStorage.setItem('expires_in', auth.auth_token.expires_in.toString());
    localStorage.setItem('userName', auth.auth_token.userName);
    localStorage.setItem('isAdmin', auth.auth_token.isAdmin ? 'true' : 'false');
  }

  public static clearLocalStorage() {
    localStorage.removeItem('id');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('expires_in');
    localStorage.removeItem('userName');
    localStorage.removeItem('isAdmin');
  }
}
